import Sunny16BaseService from '@/services/Sunny16BaseService'

import { SubjectBasicsStorefrontDto } from '@VelocitySquared/sunny16-commerce-dataobjects/storefront'
import { BookingCatalogDto } from '@VelocitySquared/sunny16-commerce-dataobjects/storefront/booking'

class Sunny16CommerceBookingCatalogService extends Sunny16BaseService {
  constructor() {
    super(
      import.meta.env.VITE_SUNNY_16_STOREFRONT_API_BASE_URL,
      'Sunny16CommerceBookingCatalogService'
    )
  }

  async getBookingCatalog(catalogPath: string): Promise<BookingCatalogDto> {
    const mockFile = import.meta.env.VITE_MOCK_CATALOG_FILE
    if (mockFile) {
      const url = mockFile.startsWith('http') ? mockFile : `/mock-data/${mockFile}`
      const response = await fetch(url)
      return await response.json()
    }
    try {
      const dataPayload = new SubjectBasicsStorefrontDto()

      dataPayload.catalogPath = catalogPath

      const response = await this.axiosInstance.post(`/booking/catalog/`, dataPayload)
      return response.data
    } catch (error) {
      throw error
    }
  }
}

export default Sunny16CommerceBookingCatalogService
